import { SCHEDULE_ORG, SHORT_FOCUS_ORG } from "./orgIds.js";

export function caseDeadline(base: number, organizations: readonly string[]): number {
  let value = base;
  if (organizations.includes(SCHEDULE_ORG)) value += 1;
  if (organizations.includes(SHORT_FOCUS_ORG)) value -= 1;
  return Math.max(1, value);
}
